export default __webpack_public_path__ + "static/JosefinSans-Light-9a1b76defafdaa3ff082164399b53e97.woff";